import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import useSteps from '../../hooks/useSteps'

export default function CartStep ({ step }) {

    const {getStep, currentStepIndex, goToStep} = useSteps()

    const stepClassNames = classNames('mtt-cart-step', {
        'mtt-cart-step--active': currentStepIndex >= step
    })

    return (
        <li className={stepClassNames}>
            { getStep(step).title }
        </li>
    )
}

CartStep.propTypes = {
    step: PropTypes.number
}